<template>
  <div class="main">
    <c-panel title="Abastecimento" titleIcon="fas fa-gas-pump">
      <form-abastecimento :paramId="id" @onSubmitAbastecimento="afterSubmit"></form-abastecimento>
    </c-panel>
  </div>
</template>

<script>
import formAbastecimento from "./form"

export default {
  components: { formAbastecimento },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/abastecimento') }
  }
}
</script>

